import React from "react";
import Balance from "../components/Balance";
import FilterTransaction from "../components/FilterTransaction";
import Layout from "../components/Layout";
import Pagination from "../components/Pagination";
import Transactions from "../components/Transactions/Transactions";
const TransactionsList = () => {

  return (
    <Layout>
      <Balance />
      <FilterTransaction />
      <Transactions />
      <Pagination />
    </Layout>
  );
};

export default TransactionsList;
